<template>
   
  <v-dialog
        v-model="dialog"
        persistent
        max-width="600px"
    >
        <div class="chatroom">
            <div class="form-header">
                <h2></h2>
                <button class="close-btn" @click.prevent="dialog = false">&times;</button>
            </div>
            <div class="cropper-container">
                <div class="cropper-wrapper">
                    <vue-cropper
                        ref="cropper"
                        :src="imgSrc"
                        :aspect-ratio="1"
                        :view-mode="1"
                        :drag-mode="'crop'"
                        :guides="true"
                        :center="true"
                        :highlight="false"
                        :background="true"
                        :auto-crop-area="0.8"
                        :crop-box-resizable="true"
                        style="height: 100%; max-width: 100%;"
                    ></vue-cropper>
                    
                    <div class="button-container">
                        <button type="submit" class="submit-btn" @click="getCroppedImage" >
                            <template>
                                Crop
                            </template>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

export default {
    name :'ImageCropper',
    props: {
        dialog: {
            type: Boolean,
            default: false
        },
        imgSrc: {
            type: String,
            default: ''
        }
    },
    watch: {
        imgSrc(newVal) {
            if (newVal) {
                this.dialog = true;
                this.$nextTick(() => {
                    this.$refs.cropper.replace(newVal);
                });
            }
        }
    },
    data() {
        return {
            croppedImageUrl: ''
        };
    },
    components:{
        VueCropper
    },
    methods: {
        getCroppedImage() {
            // Get canvas with initial crop
            const canvas = this.$refs.cropper.getCroppedCanvas({
                width: 300,
                height: 300,
                imageSmoothingEnabled: true,
                imageSmoothingQuality: 'high',
            })
            
            // Create a temporary canvas for circular mask
            const tempCanvas = document.createElement('canvas')
            const ctx = tempCanvas.getContext('2d')
            tempCanvas.width = canvas.width
            tempCanvas.height = canvas.height
            
            // Create circular clipping path
            ctx.beginPath()
            ctx.arc(
                canvas.width / 2,
                canvas.height / 2,
                Math.min(canvas.width, canvas.height) / 2,
                0,
                Math.PI * 2
            )
            ctx.closePath()
            ctx.clip()
            
            // Draw the cropped image
            ctx.drawImage(canvas, 0, 0)
            
            // Convert to data URL
            this.$emit('handleCroppedImage', tempCanvas.toDataURL())
        }
    }
    
}
</script>

<style scoped>
.cropper-container {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 1rem;
}

.cropper-wrapper {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 1rem;
  background: white;
}

.button-container {
  margin-top: 1rem;
  text-align: center;
}

.crop-button {
  padding: 0.5rem 1rem;
  background-color: #4a90e2;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.crop-button:hover {
  background-color: #357abd;
}

.preview-container {
  margin-top: 1rem;
}

.preview-container h3 {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.circular-preview {
  width: 128px;
  height: 128px;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid #ddd;
}

.circular-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
<!-- <style scoped>
.image-cropper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.crop-container {
  position: relative;
  width: 300px;
  height: 300px;
  overflow: hidden;
  border: 1px solid #ccc;
}

.crop-circle {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 200px;
  height: 200px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
}

.crop-container img {
  position: absolute;
  cursor: grab;
}
</style> -->